import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getBlogs} from "../../../utils/cms.utils";

function truncateText(text = "", max = 50, minEllipsis = 25) {
    if (!text) return "";

    // strip HTML tags
    const plain = text.replace(/<[^>]*>?/gm, "").trim();

    if (plain.length <= max) return plain;
    if (plain.length <= minEllipsis) return plain;

    return plain.slice(0, max) + "…";
}


const Blog = () => {
    const [blogData, setBlogData] = useState([]);

    useEffect(() => {
        const blogs = getBlogs();
        setBlogData(Array.isArray(blogs) ? blogs : []);
    }, []);

    // tampilkan max 3, aktif saja
    const blogItem = blogData
        .filter(b => b.isActive)
        .slice(0, 3);

    if (!blogItem.length) return null;

    return (
        <section className="blog__one section-padding-two pt-5 pb-5">
            <div className="container">

                {/* ===== TITLE ===== */}
                <div className="row mb-55">
                    <div className="col-xl-12">
                        <div className="blog__one-title t-center">
                            <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">
                                News & Blog
                            </span>
                            <h2 className="wow fadeInRight" data-wow-delay=".6s">
                                Update News & Blogs
                            </h2>
                        </div>
                    </div>
                </div>

                {/* ===== BLOG LIST ===== */}
                <div className="row justify-content-center">
                    {blogItem.map((item, index) => (
                        <div
                            key={item.id}
                            className="col-xl-4 col-lg-6 mb-30 wow fadeInUp"
                            data-wow-delay={`${index * 0.2}s`}
                        >
                            <div className="blog__headline-card">

                                {/* META */}
                                <div className="blog__headline-meta">
                                    <i className="fa-regular fa-calendar"></i>
                                    <span>News</span>
                                </div>

                                {/* TITLE */}
                                <h3 className="blog__headline-title">
                                    <Link to={`/blog/${item.id}`}>
                                        {item.title}
                                    </Link>
                                </h3>

                                {/* SUMMARY */}
                                <p className="blog__headline-summary">
                                    {truncateText(item.summaryEn, 200, 25)}
                                </p>
                                <div className='divider'/>
                                <p className="blog__headline-summary-id">
                                    {truncateText(item.summaryId, 200, 25)}
                                </p>

                                {/* CTA */}
                                <Link
                                    to={`/blog/${item.id}`}
                                    className="blog__headline-link"
                                >
                                    Read More <i className="flaticon-right-up"></i>
                                </Link>

                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Blog;
